import React from 'react';
import { Box } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import PaidIcon from '@mui/icons-material/Paid';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import CategoryIcon from '@mui/icons-material/Category';
import BadgeIcon from '@mui/icons-material/Badge';
import TimelineIcon from '@mui/icons-material/Timeline';
import StatCard from './shared/StatCard';
import { t } from '../../../utils/textUtils';
import { formatDate, formatCurrency, formatStatus, getDisplayName } from './utils/formatters';
import { OVERVIEW_GRID_SX } from './utils/constants';

const ProjectStatCards = ({ project }) => (
  <Box sx={{ ...OVERVIEW_GRID_SX, mb: 4 }}>
    <StatCard
      label={t('TANGGAL MULAI')}
      value={formatDate(project.startDate)}
      icon={<EventIcon />}
      accent="#6366F1"
    />
    <StatCard
      label={t('TANGGAL SELESAI')}
      value={formatDate(project.estimatedEndDate)}
      icon={<EventAvailableIcon />}
      accent="#0EA5E9"
    />
    <StatCard
      label={t('TOTAL AREA')}
      value={project.luasTotalBangunan ? `${project.luasTotalBangunan} m²` : t('TIDAK DITENTUKAN')}
      icon={<SquareFootIcon />}
      accent="#14B8A6"
    />
    <StatCard
      label={t('NILAI PROYEK')}
      value={formatCurrency(project.totalAnggaran)}
      icon={<PaidIcon />}
      accent="#16A34A"
    />
    <StatCard
      label={t('JENIS PROYEK')}
      value={project.jenisProyek || t('TIDAK DITENTUKAN')}
      icon={<HomeWorkIcon />}
      accent="#F59E0B"
    />
    <StatCard
      label={t('SEKTOR')}
      value={project.sektor || t('TIDAK DITENTUKAN')}
      icon={<CategoryIcon />}
      accent="#8B5CF6"
    />
    <StatCard
      label={t('MANAJER PROYEK')}
      value={getDisplayName(project.manager, t('BELUM DITUGASKAN'))}
      icon={<BadgeIcon />}
      accent="#3B82F6"
    />
    <StatCard
      label={t('STATUS')}
      value={formatStatus(project.status)}
      icon={<TimelineIcon />}
      accent="#EC4899"
    />
  </Box>
);

export default ProjectStatCards;
